export default __webpack_public_path__ + "static/deep-dive-desktop-161172c41b64bff7f82e437ccff7b34c.webp";